import { createAsyncThunk } from "@reduxjs/toolkit";
import { ArquivoAnexoJsonModel } from "../models/arquivoAnexo/arquivoAnexoJsonModel";
import { ArquivoAnexoModel } from "../models/arquivoAnexo/arquivoAnexoModel";
import { BuscaUrlPreAssinada } from "../models/arquivoAnexo/chamadas/buscaUrlPreAssinada";
import { resetArquivoAnexo, setModalAnexo, setModalArquivo, setModalDeletarArquivoAnexo } from "../redux/slices/arquivoAnexo/arquivoAnexoSlice";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import api from "../util/api";
import { toastError, toastSucess } from "../util/toast";
import { buscarContaFinanceira } from "./contaFinanceiraService";
import { buscarLancamentoBancario } from "./lancamentoBancarioService";

export const cadastrarArquivoAnexo = createAsyncThunk("/ArquivoAnexo/CadastrarArquivoAnexo", async (payload: { value: ArquivoAnexoModel; busca: any; origem: string }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    var arquivoJson: ArquivoAnexoJsonModel[] = [];

    for (const v of payload.value.arquivoAnexo) {
      if (typeof v.caminhoArquivo !== "string") {
        //recuperar url
        let buscaUrl: BuscaUrlPreAssinada = {
          fileName: v.nome,
          contentType: v.extensaoArquivo,
        };

        const retorno = await api.get("/ArquivoAnexo/presigned-url", {
          params: { fileName: buscaUrl.fileName, contentType: buscaUrl.contentType },
        });

        const uploadRes = await fetch(retorno.data.data.url, {
          method: "PUT",
          headers: {
            "Content-Type": v.extensaoArquivo!,
            "x-amz-acl": "public-read",
          },
          body: v.caminhoArquivo,
        });

        if (!uploadRes.ok) {
          toastError("Ocorreu um erro ao fazer o upload do arquivo");
          throw new Error("Erro ao fazer upload para o S3");
        }

        const fileUrl = retorno.data.data.url.split("?")[0];

        var detalhes = {
          caminhoArquivo: fileUrl,
          extensaoArquivo: v.extensaoArquivo || "application/octet-stream",
          idTipoArquivoAnexo: v.idTipoArquivoAnexo,
          observacao: v.observacao,
          nome: v.nome,
        };

        arquivoJson.push(detalhes);
      } else {
        arquivoJson.push(v);
      }
    }

    payload.value.arquivoAnexo = arquivoJson;

    await api.post("/ArquivoAnexo/CadastrarArquivoAnexo", payload.value);
    dispatch(setModalArquivo(false));
    toastSucess("Arquivos cadastrados com sucesso");
    dispatch(setLoading(false));

    dispatch(resetArquivoAnexo());

    if (payload.origem === "contaFinanceira") {
      dispatch(buscarContaFinanceira(payload.busca));
    } else {
      dispatch(buscarLancamentoBancario(payload.busca));
    }
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const cadastrarArquivoAnexoSorteio = createAsyncThunk("/ArquivoAnexo/CadastrarArquivoAnexoSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    var arquivoJson: ArquivoAnexoJsonModel[] = [];

    for (const v of payload.dataSource) {
      //recuperar url
      let busca: BuscaUrlPreAssinada = {
        fileName: v.arquivo.name,
        contentType: v.arquivo.type!,
      };

      const retorno = await api.get("/ArquivoAnexo/presigned-url", {
        params: { fileName: busca.fileName, contentType: busca.contentType },
      });

      const uploadRes = await fetch(retorno.data.data.url, {
        method: "PUT",
        headers: {
          "Content-Type": v.arquivo.type!,
          "x-amz-acl": "public-read",
        },
        body: v.arquivo.originFileObj,
      });

      if (!uploadRes.ok) {
        toastError("Ocorreu um erro ao fazer o upload do arquivo");
        throw new Error("Erro ao fazer upload para o S3");
      }

      const fileUrl = retorno.data.data.url.split("?")[0];

      var detalhes = {
        caminhoArquivo: fileUrl,
        extensaoArquivo: v.arquivo.type || "application/octet-stream",
        idTipoArquivoAnexo: 12, //Isso vem de banco, se haver modificações, alterar
        observacao: v.observacao,
        nome: v.arquivo.name,
      };

      arquivoJson.push(detalhes);
    }

    payload.value.arquivoAnexo = arquivoJson;

    await api.post("/ArquivoAnexo/CadastrarArquivoAnexoSorteio", payload.value);
    toastSucess("Arquivos cadastrados com sucesso");
    dispatch(setModalAnexo(false));
    dispatch(setLoading(false));

    dispatch(listarArquivoAnexo(payload.value.idOrigem));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const listarArquivoAnexo = createAsyncThunk("/ArquivoAnexo/ListarArquivoAnexo", async (idOrigem: number) => {
  try {
    const data = await api.get("/ArquivoAnexo/ListarArquivoAnexo", {
      params: { idOrigem: idOrigem },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarTipoArquivoAnexo = createAsyncThunk("/ArquivoAnexo/ListarTipoArquivoAnexo", async (origem: string) => {
  try {
    const data = await api.get("/ArquivoAnexo/ListarTipoArquivoAnexo", {
      params: { origem: origem },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const deletarArquivoAnexo = createAsyncThunk("/ArquivoAnexo/DeletarArquivoAnexo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/ArquivoAnexo/DeletarArquivoAnexo", {
      params: { id: payload.value },
    });
    toastSucess("Arquivos removido com sucesso");
    dispatch(setModalDeletarArquivoAnexo(false));
    dispatch(setLoading(false));

    dispatch(listarArquivoAnexo(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
